<script>
import {goto} from "$app/navigation";
import Button from "$lib/elements/Button.svelte";
import {locale, translate} from "$lib/i18n";

</script>

<div class="my-16 bg-primary-blue p-9 rounded-2xl">
  <div class="">
    <h1 class="text-white font-bold mb-4">{$translate('ForzaBet: Unmatched Online Casino & Sports Betting Experience!')}</h1>
    <p class="text-primary-lightBlue text-sm pb-2">
      {$translate('ForzaBet offers a thrilling and dynamic online casino experience designed for gaming enthusiasts. As a leader in the online gaming industry, ForzaBet provides an exciting adventure with top-tier casino games and live sports betting. Our platform supports traditional currencies, ensuring that players around the globe are catered to with a wide variety of deposit options')}
    </p>
    <p class="text-primary-lightBlue text-sm pb-2">
      {$translate('What sets ForzaBet apart is our commitment to a seamless gaming experience, featuring fast payouts, 24/7 customer support, and a user-friendly interface. Our website is designed for both casual players and high-rollers, offering a diverse selection of casino games that promise an unforgettable experience.')}
    </p>
  </div>

  <div class="pl-2">
    <div class="my-4">
      <h2 class="text-white font-bold pb-2">{$translate('Spin & Win at ForzaBet')}</h2>
      <p class="text-primary-lightBlue text-sm">
        {$translate('Explore Premier Slots at ForzaBet! Dive into our selection of high-quality slots, created by industry-leading developers. From classic favorites to the latest releases, our slots cater to all tastes and skill levels. Don’t miss out on some of our top games: "Gates Of Olympus" by Pragmatic Play, "Book of Dead" by PlaynGo, "Starburst" by NetEnt, and "Big Bass Bonanza" by Reel Kingdom.')}
      </p>
    </div>

    <div class="mt-4">
      <h2 class="text-white font-bold pb-2 pt-2">{$translate('Live Blackjack, Roulette, and More!')}</h2>
      <p class="text-primary-lightBlue text-sm">
        {$translate('Experience thrilling live casino gaming with ForzaBet’s real-time table games. Whether you’re playing Blackjack, Roulette, or Baccarat, our professional dealers provide an authentic and engaging atmosphere. Our live casino features HD streaming for a truly immersive experience, giving you the excitement of a physical casino from the comfort of your home.')}
      </p>
      <div class="pt-2">
        <h4 class="text-white font-bold pb-2 pt-2">{$translate('Live Blackjack')}
        </h4>
        <p class="text-primary-lightBlue text-sm">
          {$translate('Take a seat at ForzaBet\'s Live Blackjack tables and challenge the dealer in real-time. Use strategy and skill to beat the house and aim for 21!')}
        </p>
      </div>

      <div class="pt-2">
        <h4 class="text-white font-bold pb-2 pt-2">{$translate('Live Roulette')}
        </h4>
        <p class="text-primary-lightBlue text-sm">
          {$translate('Spin the wheel with Live Roulette at ForzaBet. Choose from European, American, or French versions and place your bets as the wheel turns in real-time.')}
        </p>
      </div>

      <div class="pt-2">
        <h4 class="text-white font-bold pb-2 pt-2">{$translate('Live Baccarat')}
        </h4>
        <p class="text-primary-lightBlue text-sm">
          {$translate('Experience elegance and simplicity with ForzaBet\'s Live Baccarat. Play live with professional dealers and immerse yourself in this thrilling, strategic card game.')}
        </p>
      </div>
    </div>

    <div class="mt-4">
      <h2 class="text-white font-bold pb-2 pt-2">{$translate('Game Shows')}</h2>
      <p class="text-primary-lightBlue text-sm">{$translate('Step into ForzaBet\'s Game Shows, where fun meets betting! Join our live-action game shows, place your bets, and interact with hosts for a chance to win big. This is where the entertainment of game shows meets the excitement of casino gaming.')} </p>
    </div>

    <div class="mt-4">
      <h2 class="text-white font-bold pb-2 pt-2">{$translate('Forza Mini Games')}</h2>
      <p class="text-primary-lightBlue text-sm">{$translate('At ForzaBet, you can enjoy mini-games that deliver fast-paced excitement with a Provably Fair system. Test your luck on our unique mini-games and experience secure, transparent betting')} </p>
    </div>

    <div class="mt-4">
      <h2 class="text-white font-bold pb-2 pt-2">{$translate('Casino Weekly Gallop Tournament')}</h2>
      <p class="text-primary-lightBlue text-sm">
        {$translate('Join the non-stop action of ForzaBet\'s weekly tournaments! Compete in exciting slot tournaments and climb the leaderboard for a chance to win amazing prizes. Whether you’re playing for total bets or total wins, our tournaments add an extra layer of excitement to your gaming.')}
      </p>
    </div>

    <div class="mt-4">
      <h2 class="text-white font-bold pb-2 pt-2">{$translate('Cashback')}</h2>
      <p class="text-primary-lightBlue text-sm">
        {$translate('Earn 10% cashback every week at ForzaBet! We value your loyalty, and as a token of appreciation, we offer regular cashback rewards for VIP Players. This is our way of enhancing your gaming experience and saying thanks for playing with us.')}
      </p>
    </div>

    <div class="mt-4">
      <h2 class="text-white font-bold pb-2 pt-2">{$translate('Free Spins')}</h2>
      <p class="text-primary-lightBlue text-sm">
        {$translate('Every deposit at ForzaBet comes with a chance for free spins. Make a deposit, and you could trigger a random set of free spins on top of your usual rewards.')}
      </p>
    </div>

    <div class="mt-4">
      <h2 class="text-white font-bold pb-2 pt-2">{$translate('Welcome Bonuses')}</h2>
      <p class="text-primary-lightBlue text-sm pb-2">
        {$translate('Start your journey at ForzaBet with exciting welcome bonuses tailored to elevate your gaming experience! Whether you\'re a crypto enthusiast or prefer traditional currencies, we’ve got you covered with exclusive offers on your first three deposits.')}
      </p>
      <p class="text-primary-lightBlue text-sm">
        {$translate('Before you dive in, be sure to explore our different welcome bonuses - choose the one that best fits your play style. We offer special rewards for both crypto players and real money deposits, so make sure you understand the options to get the most out of your ForzaBet experience!')}
      </p>
    </div>

    <div class="mt-4">
      <h2 class="text-white font-bold pb-2 pt-2">{$translate('Game Providers')}</h2>
      <p class="text-primary-lightBlue text-sm">{$translate('At ForzaBet, we partner with the best game providers to deliver high-quality gaming experiences. Our top providers include: NetEnt, Pragmatic Play, PlaynGo, Evolution Gaming, Blueprint Gaming, and more. Whether you\'re looking for slots or live dealer games, ForzaBet has you covered.')}</p>
    </div>

    <div class="mt-4">
      <h2 class="text-white font-bold pb-2 pt-2">{$translate('Secure Gaming & Fast Transactions')}</h2>
      <p class="text-primary-lightBlue text-sm">{$translate('ForzaBet ensures a safe and secure gaming environment with fast deposits and withdrawals. Play with confidence, knowing that your funds and personal information are protected with the latest encryption technology. Our platform supports a variety of payment methods for your convenience, making deposits and withdrawals simple and fast.')}</p>
    </div>

    <div class="mt-4">
      <h2 class="text-white font-bold pb-2 pt-2">{$translate('Play Anywhere, Anytime')}</h2>
      <p class="text-primary-lightBlue text-sm">{$translate('ForzaBet’s mobile-friendly platform allows you to enjoy all of your favorite games from any device. Whether you’re on your computer or mobile, your casino experience is seamless, with top-quality graphics and fast gameplay.')}</p>
    </div>
  </div>









</div>
